import { useMutation, useQueryClient } from '@tanstack/react-query';
import type { AgentApiJobPostImportRequestsRecord } from '@/types/serializers';

type UpdateRequest = {
  cols_mapping: AgentApiJobPostImportRequestsRecord['cols_mapping'];
};

export default function useUpdateJobPostImportRequest(encryptId: string) {
  const queryClient = useQueryClient();
  const token = (document.getElementsByName('csrf-token')[0] as HTMLMetaElement).content;

  return useMutation({
    mutationFn: async ({ cols_mapping }: UpdateRequest) => {
      const response = await fetch(`/agent/api/job_post_import_requests/${encryptId}`, {
        method: 'PATCH',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
          'X-CSRF-Token': token,
        },
        body: JSON.stringify({
          cols_mapping: JSON.stringify(cols_mapping),
        }),
      });

      if (!response.ok) {
        const errorData = await response.json().catch(() => ({ errors: ['更新に失敗しました'] }));
        throw new Error(errorData.errors?.[0] || errorData.message || '更新に失敗しました');
      }

      const data: AgentApiJobPostImportRequestsRecord = await response.json();
      return data;
    },
    onSuccess: () => {
      // キャッシュを無効化して最新のデータを取得
      queryClient.invalidateQueries({ queryKey: ['JobPostImportRequest', encryptId] });
    },
  });
}
